export * from './lib/cookies.service.module';

export { AccredibleCookiesService } from './lib/cookies.service';
